// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { InvoicingSubscriptions } from '../../../../types/server/modules/invoicing/subscriptions';

export type * from '../../../../types/server/modules/invoicing/subscriptions';

export const createSubscriptions = ( requests: Requests ): InvoicingSubscriptions => ({
  BillingEntities: ( params, onChange ) => {
          return requests.subscribe( `/billing-entities/:id?`, params, 'BillingEntities', onChange );
          },
  FiscalDocuments: ( params, onChange ) => {
          return requests.subscribe( `/fiscal-documents/:id?`, params, 'FiscalDocuments', onChange );
          }
});
